import { render, staticRenderFns } from "./processed_image.vue?vue&type=template&id=b204d55c&"
import script from "./processed_image.vue?vue&type=script&lang=ts&"
export * from "./processed_image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports